<template>
    <form-container :title="stageTitle">

      <form-yes-no-radio-list 
        class="bumper"
        id="confirmUK" 
        v-model="ukResident" 
        label="Are you a UK Resident?"
        validationFieldLabel="confirmUK"
        validationInvalidFeedback="Please indicate whether you are a UK resident">
      </form-yes-no-radio-list>

      <form-yes-no-radio-list 
        class="bumper"
        id="confirmVAT" 
        v-model="vatRegistered" 
        label="Are you VAT registered?"
        validationFieldLabel="confirmVAT"
        validationInvalidFeedback="Please indicate whether you are VAT registered">
      </form-yes-no-radio-list>

      <form-button-bar
            :back_button_show='false'
            :next_button_enable='true'
            :next_button_show='true'
            :next_button_icon_enable='true'
            
            :next_button_action='handleNextClick' />
    </form-container>
</template>

<script>

import tigaClaimForm from '@/mixins/tigaClaimForm'
import FormContainer from '@/components/FormContainer.vue'
import FormYesNoRadioList from '@/components/FormYesNoRadioList.vue'
import FormButtonBar from '@/components/standaloneForm/FormButtonBar.vue'

export default {
  name: 'aboutYou',
  props: {
    value: {
      required: false
    }
  },
  components: {
    FormContainer,
    FormYesNoRadioList,
    FormButtonBar
  },
  mixins: [
    tigaClaimForm
  ],
  data () {
    return {
      nextAttempted: false
    }
  },
  watch: {

  },
  computed: {
    ukResident: {
      get () {
        return this.$store.state.claimform.claimForm.data.claimant.ukResident
      },
      set (value) {
        this.$store.commit('claimform/setResidency', { ukResident: value })
      }
    },
    vatRegistered: {
      get () {
        return this.$store.state.claimform.claimForm.data.claimant.vatRegistered
      },
      set (value) {
        this.$store.commit('claimform/setTaxStatus', { vatRegistered: value })
      }
    },
    stageTitle() {
      return this.$textManager.getText("title", this.$route.name)
    }
  },
  methods: {
    handleNextClick () {
      this.nextAttempted = true
      if (this.checkForm()) {
        this.$router.push({ path: '8' })
      }      
    }
  },
  mounted () {
    if (!this.claimformHasPolicyNumber || !this.claimformHasClaimant || !this.claimformHasIncidentType) {
      this.gotoStage1();
    }
  }
}
</script>

<style>

</style>
